import { Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';

@Injectable({
    providedIn: 'root'
})

export class StorageService {
    private storageTmp: Storage | null = null;

    constructor(private storage: Storage) {
        // this.init().then().catch(e => console.log('StorageService error:', e));
    }

    async init() {
        // If using, define drivers here: await this.storage.defineDriver(/*...*/);
        try {
            this.storageTmp = await this.storage.create();
            if (!this.storageTmp) {
                console.log('StorageService Create Error');
            }
        } catch (e) {
            console.log('StorageService Create Error', e);
        }

    }

    // Create and expose methods that users of this service can
    // call, for example:
    public async set(key: string, value: any) {
        try {
            await this.init();
            const val = String(key);
            return await this.storageTmp?.set(val, value);
        } catch (e) {
            console.log('StorageService set error', e);
            return null;
        }
    }

    public async get(key: string) {
        try {
            await this.init();
            const val = String(key);
            return await this.storageTmp?.get(val);
        } catch (e) {
            console.log('StorageService get error', e);
            return null;
        }
    }
}
